import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dum-objetivo',
  templateUrl: './objetivo.component.html',
  styleUrls: ['./objetivo.component.scss'],
})
export class ObjetivoComponent implements OnInit {
  constructor() { }

  ngOnInit(): void { }
}
